import '@Global/modal';
import {createRoot} from 'react-dom/client';
import App from '@Components/app';
import {ModalContainer} from '@Components/modal-container';
import {CreateWithAiPromptBox} from '@Components/create-with-ai-prompt-box/create-with-ai-prompt-box';
import {AiChatSource} from '@Components/ai-chat-window/ai-chat-window.types';
import {AiChatStartSource} from '@Libraries/ga-events';
import {AI_LP_HERO_PROMPT_BOX_ID, LANDING_PAGE_AI_PROMPT_BOX_ID} from './landing-page-ai-chat.types';

function mountPromptBox(containerId: string): void {
  const container = document.getElementById(containerId);
  if (!container) {
    return;
  }
  const root = createRoot(container);
  root.render(
    <App className="_full-width">
      <ModalContainer />
      <CreateWithAiPromptBox
        promptBoxId={containerId}
        chatSource={AiChatSource.SEO_LANDING_PAGE}
        startSource={AiChatStartSource.SEO_LANDING_PAGE}
        blockClasses="l-ai-chat-section-prompt-box"
        inputClasses="l-ai-chat-section-prompt-box-input"
        showTemplatesButton
        authenticateBeforeSubmit
        showInitialAnimation={false}
      />
    </App>
  );
}

mountPromptBox(LANDING_PAGE_AI_PROMPT_BOX_ID);
mountPromptBox(AI_LP_HERO_PROMPT_BOX_ID);
